module.exports = __webpack_public_path__ + "img/gentlemen-club-carousel-11.cbd10a24.png";